import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GridHeader } from '../models/gridHeader';
import { GroupType } from '../types/group-type';

@Component({ template: '' })
export abstract class HeaderWidgetComponent {
  @Input() header: GridHeader;
  @Input() selectedGroup: GroupType;
  @Input() isLast: boolean;
  @Input() enableSearch: boolean;
  @Output() searchEvent: EventEmitter<any> = new EventEmitter<any>();
}
